import React, { useState } from 'react';
import { NavLink, Link } from 'react-router-dom';
import { Menu, X, Bike } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);

  const navLinks = [
    { name: 'Home', path: '/' },
    { name: 'Services', path: '/services' },
    { name: 'Partnership', path: '/partnership' },
    { name: 'About', path: '/about' },
    { name: 'Contact', path: '/contact' },
  ];

  // Active Link Styling
  const activeStyle = "text-[#0099FF] font-bold border-b-2 border-[#0099FF]";
  const normalStyle = "text-white/80 hover:text-white transition-all duration-300";

  return (
    <nav className="fixed top-0 left-0 right-0 bg-[#032B53] shadow-2xl z-[100] border-b border-white/5">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-20">
        
          <Link to="/" className="flex items-center gap-2 group">
            <div className=" p-1.5 rounded-lg group-hover:rotate-12 transition-transform">
        <img 
                src="/logo.png" 
                alt="UCorier Logo" 
                className="h-10 w-auto object-contain transition-transform group-hover:scale-105" 
              />
            </div>
            <span className="text-xl font-black text-white tracking-tighter uppercase">
              ucorier <span className="text-[#0099FF]">kft</span>
            </span>
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-8">
            {navLinks.map((link) => (
              <NavLink
                key={link.name}
                to={link.path}
                className={({ isActive }) => 
                  `text-sm uppercase tracking-widest pb-1 ${isActive ? activeStyle : normalStyle}`
                }
              >
                {link.name}
              </NavLink>
            ))}
          </div>

          {/* Mobile Toggle */}
          <div className="md:hidden flex items-center">
            <button
              onClick={() => setIsOpen(!isOpen)}
              className="text-white p-2 hover:bg-white/10 rounded-xl transition-colors"
            >
              {isOpen ? <X size={28} /> : <Menu size={28} />}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Menu with Animation */}
      <AnimatePresence>
        {isOpen && (
          <motion.div
            initial={{ opacity: 0, height: 0 }}
            animate={{ opacity: 1, height: 'auto' }}
            exit={{ opacity: 0, height: 0 }}
            className="md:hidden bg-[#032B53] border-t border-white/10 overflow-hidden"
          >
            <div className="px-4 pt-4 pb-8 space-y-2">
              {navLinks.map((link) => (
                <NavLink
                  key={link.name}
                  to={link.path}
                  onClick={() => setIsOpen(false)}
                  className={({ isActive }) => 
                    `block px-4 py-3 rounded-xl text-lg font-bold ${
                      isActive ? "bg-[#0099FF] text-white" : "text-white/70"
                    }`
                  }
                >
                  {link.name}
                </NavLink>
              ))}
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </nav>
  );
};

export default Navbar;